import { faEdit, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import Table from '../../Common/table';
import swal from 'sweetalert';
import axios from 'axios';
import dateTime from '../../utill/dateTime';
import api from '../../config.json'
import Loading from '../../utill/LoadingComponent';

const CheckpointConfigList = ({ history ,RightName,getRightsForAccess,Heading}) => {
    const [list, setList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [sortColumn,setSortColumn]=useState({path:'FieldName',order:'asc'})

    useEffect(() => {
        Heading('Configure Checkpoint')
        handleGetData()
    }, [])

    const handleGetData = () => {
        setLoader(true)
        axios.get(api.api + 'checkPointConfig')
            .then((result) => {
                // consol(result.data)
                setLoader(false)
                setList(result.data);
            })
            .catch((err) => {
                swal(`${err}`)
                setLoader(false)
            })
    }

    const onDelete = (data) => {
        swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this",
            icon: "warning",
            buttons: true,
            dangerMode: true
        }).then(willDelete => {
            if (willDelete) {
                // this.setState({ querySuccess: true });
                axios
                    .delete(api.api + "checkPointConfig/" + data._id, { data: data })
                    .then(result => {
                        // consol(result.data)
                        if (result.data.ok === 1 && result.data.deletedCount === 1) {
                            let filterData = list.filter(
                                obj => obj._id !== data._id
                            );
                            setList(filterData)
                            setLoader(false)
                        }
                    })
                    .catch(err => {
                        setLoader(false)
                        swal(`${err.response.data.message}`);
                    });
            } else {
                setLoader(false)
                // swal("Your imaginary file is safe!");
            }
        });
    }


    const columns = [
        { path: 'Name', label: 'Template Name' },
        { key: 'Columns', label: 'Columns Name',content: (obj) => <React.Fragment>{obj.Columns && obj.Columns.map(one=>one.FieldName).join(' | ')}</React.Fragment> },
        { key: 'createdAt', label: 'Created Date', content: (obj) => <React.Fragment><label>{dateTime.getStringOfDateTime(obj.createdAt)}</label><br /></React.Fragment> },
        { key: 'updatedAt', label: 'Last Updated Date', content: (obj) => <React.Fragment><label>{dateTime.getStringOfDateTime(obj.updatedAt)}</label><br /></React.Fragment> },
        { key: 'update', content: user => <button disabled={!getRightsForAccess('StaticDataRights', RightName, "update")} onClick={() => history.push("/setting/checkpoint_config/form", { action: "update", data: user })} className="btn btn-sm btn-primary"><FontAwesomeIcon icon={faEdit} /></button> },
        // { key: 'view', content: user => <button onClick={() => this.props.onView(user)} className="btn btn-sm btn-info"><FontAwesomeIcon icon={faEye} /></button> },
        { key: 'delete', content: user => <button disabled={!getRightsForAccess('StaticDataRights', RightName, "update")} onClick={() => onDelete(user)} className="btn btn-sm btn-danger"><FontAwesomeIcon icon={faTrash} /></button> }

    ]

    return (<>
        <div className='text-center'>
            {loader?<Loading/>:""}
            {/* <p>Configure Checkpoint List</p> */}
        </div>
       {getRightsForAccess('StaticDataRights', RightName, "write") &&  <a onClick={() => history.push('/setting/checkpoint_config/form', { action: "add", data: {} })} style={{ cursor: 'pointer' }} className='float-right common-anchor'

        >
            <FontAwesomeIcon size='1x' icon={faPlus} /> Add </a>}
        {/* <a
          style={{ cursor: "pointer", color: 'white' }}
          className="float-left btn btn-sm btn-primary "
          //onClick={this.handleUploadGuagesDoc}
        >
          {" "}

          <FontAwesomeIcon size="1x" icon={faFileImport} /> Import Excel
        </a> */}
        {list.length < 0 ? "Data Not Available" : <Table sortColumn={sortColumn} columns={columns} data={list} />}

    </>);
}

export default CheckpointConfigList;